import { Component, ViewEncapsulation, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomerService, StorageService } from '../_services/index';
import { DataService, OptionsserviceService, LoansService } from '../_services/index';

@Component({
  selector: 'app-loancollateral',
  templateUrl: './loancollateral.component.html',
  styleUrls: ['./loancollateral.component.css']
})
export class LoancollateralComponent implements OnInit {

  public loading = false;
  @Input('parentRouteId') parentRouteId: number;
  @Input('sub') sub: any;
  @Input('sub_summary') sub_summary: any;
  @Input('where') where = '2';
  @Input('currentUser') currentUser: any;
  loan: any;
  collaterals: any;
  //token: any = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpZCI6IjExOTYiLCJlbWFpbCI6ImFkbWluQHByYWlzZWNvb3AuY29tIiwiaWF0IjoxNTUyOTA1NDE3LCJleHAiOjE1NTMxMjE0MTcsImxlbmRlcl9pZCI6IjIyNTg4IiwiaXNfY29tcGFueV9zdGFmZiI6ZmFsc2UsImNvbXBhbnlfaWQiOm51bGx9.zfnuoYmpbepRMJmWkrtDJDq19TeF2OIHYN_PKQpZ5ys";
  request_id: any = 33851;
  edit_mode: boolean = false;
  @Output() addingCollateral = new EventEmitter();
  constructor(private dataService: DataService, public route: ActivatedRoute, public storageService: StorageService,
    public optionsService: OptionsserviceService, public loansService: LoansService) {



  }
  ngOnInit() {
    this.loanAnalysis();
  }
  addNewCollateral() {
    this.addingCollateral.emit();
  }
  loanAnalysis() {
    // this.currentUser = this.storageService.read<any>('currentUser');
      this.loansService.getLoanCollateral(this.currentUser.token, this.request_id)
        .subscribe(loan => {
          this.loan = loan.loan;
          this.collaterals = loan.collaterals;
          this.calculateTotal();
        });
  }
  calculateTotal() {
    //console.log(1)
    let current_est = 0;
    let est_depre = 0;
    for (var collateral of this.collaterals) {
      current_est += Number(collateral.EST_CURRENT_VALUE);
      est_depre += Number(collateral.EST_LIQUIDATION_VALUE);
    }
    this.loan.TOTAL_COLLATERAL_CURRENT_VALUE = current_est;
    this.loan.TOTAL_COLLATERAL_EST_LIQUIDATION_VALUE = est_depre;
  }
  calculateTotal_(event) {
    //console.log(event)
    let current_est = 0;
    let est_depre = 0;
    for (var collateral of this.collaterals) {
      current_est += Number(collateral.EST_CURRENT_VALUE);
      est_depre += Number(collateral.EST_LIQUIDATION_VALUE);
    }
    this.loan.TOTAL_COLLATERAL_CURRENT_VALUE = current_est;
    this.loan.TOTAL_COLLATERAL_EST_LIQUIDATION_VALUE = est_depre;
  }
  saveCollaterals() {
    // this.loading = true;
    this.loansService.saveCollaterals(this.currentUser.token, this.parentRouteId, this.collaterals, this.loan)
      .subscribe(analysis => {
        this.loading = false;
        this.loanAnalysis()

      });
  }
  openModal(section) {
    this.dataService.onOpenApplicationsModal.emit({ section: section, request_id: this.parentRouteId, loan: this.loan });
  }
}
